// Iter159 · KPIs Pando por comercial: mide cuántas oportunidades aceptó
// cada usuario con cero ediciones respecto a la sugerencia Pando.
// Métrica clave: % no_edit — proxy de calidad de la clasificación de Pando.
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Sparkles, TrendingUp, Loader2 } from "lucide-react";
import { API } from "@/context/AuthContext";

export default function PandoStatsByUser() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/mercado/pando-stats-by-user`)
      .then(r => { if (mounted) setData(r.data); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const users = data?.users || [];
  const g = data?.global || {};

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5" data-testid="pando-stats-section">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base font-bold text-gray-900 flex items-center gap-2">
            <Sparkles size={16} className="text-indigo-600"/> Pando · Rendimiento por comercial
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Compara cada sugerencia Pando (DG · Actividad · Tipo contratación) con la decisión final del usuario al aceptar. Mayor % sin edición ⇒ mejor clasificación.
          </p>
        </div>
        {g.total > 0 && (
          <div className="text-right" data-testid="pando-stats-global">
            <div className="text-2xl font-bold text-indigo-700">{g.no_edit_pct}%</div>
            <div className="text-[10px] text-gray-500 uppercase tracking-wide">Sin edición global</div>
            <div className="text-[10px] text-gray-400">{g.no_edit} de {g.total} aceptaciones</div>
          </div>
        )}
      </div>

      {loading ? (
        <div className="py-8 text-center text-gray-400 text-sm inline-flex items-center gap-2 w-full justify-center">
          <Loader2 size={14} className="animate-spin"/> Calculando…
        </div>
      ) : users.length === 0 ? (
        <div className="py-8 text-center text-gray-400 text-sm border-2 border-dashed border-gray-200 rounded-lg">
          Aún no hay aceptaciones con sugerencia Pando previa. Ejecuta &ldquo;Batch Pando&rdquo; en MERCADO y acepta alguna oportunidad para empezar a medir.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-gray-50 text-[10px] uppercase text-gray-500">
              <tr>
                <th className="text-left p-2">Comercial</th>
                <th className="text-right p-2">Aceptaciones</th>
                <th className="text-right p-2">Sin edición</th>
                <th className="text-right p-2">% acierto</th>
                <th className="text-right p-2">Editó DG</th>
                <th className="text-right p-2">Editó Actividad</th>
                <th className="text-right p-2">Editó Tipo</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {users.map(u => (
                <tr key={u.user} className="hover:bg-gray-50" data-testid={`pando-user-row-${u.user}`}>
                  <td className="p-2 font-mono text-gray-700">{u.user}</td>
                  <td className="p-2 text-right tabular-nums">{u.total}</td>
                  <td className="p-2 text-right tabular-nums text-emerald-700 font-bold">{u.no_edit}</td>
                  <td className="p-2 text-right">
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-bold ${
                      u.no_edit_pct >= 75 ? "bg-emerald-100 text-emerald-800" :
                      u.no_edit_pct >= 50 ? "bg-amber-100 text-amber-800" :
                      "bg-rose-100 text-rose-800"
                    }`}>
                      <TrendingUp size={10}/> {u.no_edit_pct}%
                    </span>
                  </td>
                  <td className="p-2 text-right tabular-nums text-gray-500">{u.edited_dg}</td>
                  <td className="p-2 text-right tabular-nums text-gray-500">{u.edited_act}</td>
                  <td className="p-2 text-right tabular-nums text-gray-500">{u.edited_tipo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
